import { render, staticRenderFns } from "./BTHeader.vue?vue&type=template&id=32867250&scoped=true&"
import script from "./BTHeader.vue?vue&type=script&lang=js&"
export * from "./BTHeader.vue?vue&type=script&lang=js&"
import style0 from "./BTHeader.vue?vue&type=style&index=0&id=32867250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32867250",
  null
  
)

export default component.exports